import { render, staticRenderFns } from "./ConfigNet.vue?vue&type=template&id=ef36d20c&scoped=true&"
import script from "./ConfigNet.vue?vue&type=script&lang=js&"
export * from "./ConfigNet.vue?vue&type=script&lang=js&"
import style0 from "./ConfigNet.vue?vue&type=style&index=0&id=ef36d20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef36d20c",
  null
  
)

export default component.exports